// /stores/WheelAnalysis/additionalGoals.js
import { defineStore } from 'pinia'
import useWheelAnalysisQuery from '@/composables/useWheelAnalysisQuery'
import axios from 'axios'
import { useAnalysisStore } from '@/stores/Setup/analysis'
import { useCriticalGoalsStore } from '@/stores/WheelAnalysis/criticalGoals'

export const useAdditionalGoalsStore = defineStore('additionalGoals', {
    state: () => ({
        // 17 additional-goal flags (keep your initial shape)
        selectedGoals: Array(17).fill(false),

        // Keep your shape for targets (array of rows). If you know the row counts,
        // you can initialize with false booleans; empty arrays are OK as a start.
        selectedTargets: [
            [], [], [], [], [], [], [], [], [], [],
            [], [], [], [], [], [], [], [], [], [],
            [], [], [], [], [], [], [], [], []
        ],
    }),

    actions: {
        // Refs-safe updates (optional but recommended)
        setSelectedTarget(goalIdx, targetIdx, value) {
            const row = Array.isArray(this.selectedTargets[goalIdx])
                ? [...this.selectedTargets[goalIdx]]
                : []
            row[targetIdx] = !!value
            this.selectedTargets.splice(goalIdx, 1, row)
            this.selectedTargetsChanged()
        },
        setSelectedTargets(next) {
            this.selectedTargets = (next || []).map(row => [...row])
            this.selectedTargetsChanged()
        },

        updateSelectedGoals() {
            const critical = useCriticalGoalsStore()
            this.selectedGoals = [...critical.selectedCriticalGoals] // copy, don’t alias
            this.selectedGoalsChanged()
        },

        async fetchWheelAnalysis() {
            await useWheelAnalysisQuery()
        },

        selectedGoalsChanged() {
            const { wheelAnalysisId } = useAnalysisStore()
            if (wheelAnalysisId == null) return

            const payload = {
                // backend expects a String containing JSON
                additional_goals_selected_goals: JSON.stringify(this.selectedGoals),
            }

            axios.put(
                `${process.env.VUE_APP_API_ROOT}api/v1/wheel_analyses/${wheelAnalysisId}/additional_goals_selected_goals`,
                payload
            )
                .then(r => console.log('Saved additional_goals_selected_goals', r.status))
                .catch(e => console.error('Save failed (additional_goals_selected_goals):', e))
        },

        selectedTargetsChanged() {
            const { wheelAnalysisId } = useAnalysisStore()
            if (wheelAnalysisId == null) return

            const payload = {
                // backend expects a String containing JSON
                additional_goals_selected_targets: JSON.stringify(this.selectedTargets),
            }

            axios.put(
                `${process.env.VUE_APP_API_ROOT}api/v1/wheel_analyses/${wheelAnalysisId}/additional_goals_selected_targets`,
                payload
            )
                .then(r => console.log('Saved additional_goals_selected_targets', r.status))
                .catch(e => console.error('Save failed (additional_goals_selected_targets):', e))
        },


    },

    persist: true,
})
